import { ErrorResource } from "../locales";

export const error: ErrorResource = {
    couldNotSave: "Kunne ikke lagre",
    ohNoSomethingWentWrong: "Å nei, noe gikk galt! :(",
    refreshAndTryAgain: "Oppdater siden og prøv igjen.",
    goToLogin: "Gå til innlogging",
};
